var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col m-pick" }, [
    _c("p", { staticClass: "step-caption ft-bld" }, [
      _vm._v("Select content(s) to add to this row"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "all-outer" }, [
      _c(
        "div",
        { staticClass: "all" },
        _vm._l(_vm.assets, function (card, index) {
          return _c("SnapCard", {
            key: index,
            attrs: { posterSrc: card.poster, title: card.name },
            nativeOn: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.moveToSelection(index)
              },
            },
          })
        }),
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btm-ovr" }, [
      _c("div", { staticClass: "selected col" }, [
        _c("p", { staticClass: "step-caption ft-bld txt-grt" }, [
          _vm._v("Selected content(s)"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { ref: "selection", staticClass: "selection" },
          [
            _vm._l(_vm.selectedCards, function (selected, index) {
              return _c("SmallCard", {
                key: index,
                attrs: {
                  "pos-num": index + 1,
                  posterSrc: selected.poster,
                  title: selected.name,
                },
                on: { unselect: _vm.removeFromSelection },
              })
            }),
            _vm._v(" "),
            _c("div", { staticClass: "placeholder-cards" }, [
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedCards.length == 0,
                    expression: "selectedCards.length == 0",
                  },
                ],
              }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedCards.length <= 1,
                    expression: "selectedCards.length <= 1",
                  },
                ],
              }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedCards.length <= 2,
                    expression: "selectedCards.length <= 2",
                  },
                ],
              }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedCards.length <= 3,
                    expression: "selectedCards.length <= 3",
                  },
                ],
              }),
            ]),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "nxt-out" }, [
        _c(
          "div",
          {
            staticClass: "btn bck",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.switchStep("prv")
              },
            },
          },
          [_c("span", { staticClass: "txt" }, [_vm._v("Back")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn main txt-blk",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [
            _c("span", { staticClass: "hvr" }),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [_vm._v("Validate")]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }